import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputGroup, Tag, TagPicker } from 'rsuite';
import { avatars } from '@shared/static/avatars';
import { icons } from '@shared/static/icons';
import { FormGroup } from '@shared/ui/forms/display';

const renderValue = (values, items, onChange) =>
  values.map((tag, index) => (
    <Tag key={tag}>
      <div
        className="render-select-icon cursor-pointer"
        onClick={() => {
          onChange(values.filter((_, i) => i !== index));
        }}
      >
        {avatars[tag]}
        {items[index].label}
        <div className="d-flex">{icons.close}</div>
      </div>
    </Tag>
  ));

export default function MarketingPlatformsSelect({
  error,
  control,
  name,
  isRequired = true,
}) {
  const { t } = useTranslation();

  const data = [
    { label: 'Google', value: 'google' },
    { label: 'Tiktok', value: 'tiktok' },
    { label: 'Facebook', value: 'facebook' },
    { label: 'TG Ads', value: 'tg ads' },
    { label: 'Bing', value: 'bing' },
    { label: 'Twitch', value: 'twitch' },
    { label: t('other'), value: 'other' },
  ];

  return (
    <FormGroup error={error} label={t('marketing_platforms')}>
      <Controller
        control={control}
        name={name}
        rules={{ required: isRequired }}
        render={({ field }) => (
          <InputGroup
            inside
            className={`${field.value?.length > 0 ? 'has-value' : ''}`}
          >
            <TagPicker
              block
              data={data}
              onChange={field.onChange}
              placement="auto"
              preventOverflow
              value={field.value}
              cleanable={false}
              searchable={false}
              renderOption={(label, item) => (
                <div className="render-select-icon">
                  {avatars[item.value]}
                  {item.label}
                </div>
              )}
              renderValue={(values, items) =>
                renderValue(values, items, field.onChange)
              }
            />
          </InputGroup>
        )}
      />
    </FormGroup>
  );
}
